import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import moment from "moment";
import { PaginationLimit } from "../../Config";
import { useNavigate } from "react-router-dom";
import NotFoundModel from "../../Components/NotFoundModel";
import { IoMdEye, IoMdMore } from "react-icons/io";
import { MdModeEdit } from "react-icons/md";
import { RiEditFill } from "react-icons/ri";

const Table = ({
  ApiData,
  setRevokeTenantModal,
  setEditUser,
  setSelectedData,
}) => {
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);
  const navigate = useNavigate();
  const [selectedRow, setSelectedRow] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [currentPage, setCurrentPage] = useState(0);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

  const revoke = (item) => {
    // setEditUser(true);
    //setSelectedData(item);
    setRevokeTenantModal(true);
    setOpenActionMenu(null);
  };

  const editDetail = (item) => {
    setSelectedData(item);
    setEditUser(true);
    setOpenActionMenu(null);
  };

  const ActionBtns = (item) => {
    const openMenu = (id) => {
      //setPreviousId(openActionMenu);
      setOpenActionMenu((prevId) => {
        return prevId === id ? null : id;
      });
    };

    return (
      <ActionBtnWrapper>
        {openActionMenu === item.tenantId && (
          <MenuOptions id="menuOptions">
            {/* <MenuItem title="Revoke Moveout" onClick={() => revoke(item)}>
                <MdModeEdit className="text-gray-700 mr-2" /> Revoke Moveout
              </MenuItem> */}

            <MenuItem title="Edit Details" onClick={() => editDetail(item)}>
              <RiEditFill className="text-gray-700 mr-2" /> Edit Details
            </MenuItem>
          </MenuOptions>
        )}

        <Btn
          title="Actions"
          type="button"
          onClick={() => openMenu(item.tenantId)}
        >
          <IoMdMore className="text-gray-600" size={24} />
        </Btn>
      </ActionBtnWrapper>
    );
  };

  useEffect(() => {
    if (ApiData) {
      const tempData = ApiData.map((item) => ({
        tenantName: getTenantName(item),
        clientName: getOwnerName(item),
        getProperty: getProperty(item),
        rent: "₹" + item.rent,
        dues: getDues(item),
        roomNum: getBedsFloors(item),
        moveInOutDate: moveInOutDate(item),
        moveOutDate: getMoveOutDate(item),
        status: combineStatusAndKyc(item),
        action: ActionBtns(item),
      }));
      setData(tempData);
    }
  }, [ApiData, openActionMenu]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getTenantName = (item) => {
    return (
      <UserImageWrapper>
        <UserImage src={Images.Avatar} alt={`Avatar for ${item.tenantName}`} />
        <div className="flex flex-col gap-1">
          <span className="text-zinc-900 font-medium">{item.tenantName} </span>
          <span className="text-amber-500 text-xs">#{item.tenantMobile}</span>
        </div>
      </UserImageWrapper>
    );
  };

  const getOwnerName = (item) => {
    return (
      <div className="flex flex-col gap-1">
        <span className="text-zinc-900 font-medium">{item.clientName} </span>
      </div>
    );
  };

  const getStatus = (status) => {
    if (status === 1) {
      return <Initiated>Initiated</Initiated>;
    } else if (status === 2) {
      return <Moveout>Move Out</Moveout>;
    }
  };

  const combineStatusAndKyc = (item) => {
    const statusElement = getStatus(item.status);
    return (
      <div className="flex gap-1">
        <span>{statusElement}</span>
      </div>
    );
  };

  const goToDues = (clickOn, item) => {
    navigate(`/tenantdetails/${item.tenantId}`, {
      state: {
        tabName: clickOn,
        tabKey: "totalDues",
      },
    });
  };

  const getDues = (item) => {
    return (
      <span className="bg-rose-500 text-white w-16 py-2 flex items-center justify-center rounded-lg text-xs">
        <span
          className={`${"cursor-pointer font-semibold"}`}
          onClick={() => goToDues("Passbook", item)}
        >
          {"₹" + (item?.totalDues || 0)}
        </span>
      </span>
    );
  };

  const getProperty = (item) => {
    return (
      <div className="flex flex-col gap-1">
        <span className="text-zinc-600 font-medium">{item.propertyName} </span>
        <span className="text-zinc-500 text-xs">{item.clientName}</span>
      </div>
    );
  };

  const getBedsFloors = (item) => {
    return (
      <span
        className={`bg-neutral-100 text-gray-600 px-3 py-1 rounded-md text-sm cursor-pointer`}
      >
        {"#" + item?.roomNum + ", " + item?.flatName}
      </span>
    );
  };

  const moveInOutDate = (item) => {
    return (
      <div className="flex gap-3 ">
        <div className="flex flex-col ">
          <span>
            {item.moveInDate
              ? moment(item.moveInDate).format("DD-MM-YYYY")
              : "---"}
          </span>
          <span className="text-gray-400 font-medium text-xs">M.In Date</span>
        </div>
      </div>
    );
  };

  const getMoveOutDate = (item) => {
    return (
      <div className="flex gap-3 ">
        <div className="flex flex-col ">
          <span>
            {item.moveInDate
              ? moment(item.moveOutDate).format("DD-MM-YYYY")
              : "---"}
          </span>
          <span className="text-gray-400 font-medium text-xs">M.Out Date</span>
        </div>
      </div>
    );
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      // Display only "User" column for mobile screens
      return [
        {
          Header: "Tenant Name",
          accessor: "tenantName",
        },
        {
          Header: "Owner Name",
          accessor: "clientName",
        },
      ];
    }
    return [
      {
        Header: "Tenant Name",
        accessor: "tenantName",
      },
      {
        Header: "Owner Name",
        accessor: "clientName",
      },
      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Move In Date",
        accessor: "moveInOutDate",
      },
      {
        Header: "Move Out Date",
        accessor: "moveOutDate",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ];
  }, [isMobileView]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex },
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination,
  );
  useEffect(() => {
    setCurrentPage(pageIndex); // Update current page on state change
  }, [pageIndex]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                          } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody
          {...getTableBodyProps()}
          className={ApiData?.length > 0 ? "border-b" : ""}
        >
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr
                  {...row.getRowProps()}
                  className={ApiData?.length > 0 ? "border-b" : ""}
                >
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td {...cell.getCellProps()}>{cell.render("Cell")}</Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>Bed/Floor</strong> {data[rowIndex].roomNum}
                        </li>
                        <li>
                          <strong>Move In/Out Date</strong>{" "}
                          {data[rowIndex].moveInOutDate}
                        </li>
                        <li>
                          <strong>Bed/Floor</strong> {data[rowIndex].roomNum}
                        </li>
                        <li className="flex gap-2">
                          <strong>Status/KYC Status</strong>{" "}
                          {data[rowIndex].status}
                        </li>
                        <li>
                          <strong>Action:</strong> {data[rowIndex].action}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {ApiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>

          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
      {ApiData?.length === 0 && <NotFoundModel />}
    </>
  );
};
const MenuOptions = tw.div`absolute bottom-10 right-0 py-4 w-max bg-white z-50 rounded-lg shadow-lg border border-gray-200 flex flex-col`;
const MenuItem = tw.div`flex items-center gap-2 px-4 py-2 text-base font-medium cursor-pointer hover:bg-gray-100`;
const Btn = tw.button`action-btn grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;
const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-zinc-500 bg-slate-100`;
const Tbody = tw.tbody`${({ hasdata }) => (hasdata ? "border-b" : "")}`;
const Tr = tw.tr`${({ hasdata }) =>
  hasdata ? "border-b" : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-medium text-gray-500`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const UserImageWrapper = tw.div` flex items-center gap-2`;
const UserImage = tw.img`w-9 h-9 rounded-full `;
const Initiated = tw.div`bg-yellow-100 text-yellow-700 text-xs border-yellow-300 border w-24 h-7 flex items-center justify-center rounded-full`;
const Moveout = tw.div`bg-blue-100 text-blue-700 text-xs border-blue-300 border w-24 h-7 flex items-center justify-center rounded-full`;
export default Table;

// import React, { useEffect, useState } from "react";
// import { useTable, useSortBy, usePagination } from "react-table";
// import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
// import Images from "../../Images";
// import tw from "tailwind-styled-components";
// import moment from "moment";
// import { PaginationLimit } from "../../Config";
// import { useNavigate } from "react-router-dom";
// import NotFoundModel from "../../Components/NotFoundModel";
// import { IoMdEye, IoMdMore } from "react-icons/io";
// import { MdModeEdit } from "react-icons/md";

// const Table = ({
//   ApiData,
//   setRevokeTenantModal,
//   updateMoveOutMutate,
// }) => {
//   const [data, setData] = useState([
//     {
//       deviceName: "",
//       extractionTime: "",
//       processingTime: "",
//       drops: "",
//       action: "",
//     },
//   ]);
//   const navigate = useNavigate();
//   const [selectedRow, setSelectedRow] = useState(null);
//   const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
//   const [currentPage, setCurrentPage] = useState(0);
//   const [openActionMenu, setOpenActionMenu] = useState(null);
//   const toggleRow = (index) => {
//     setSelectedRow(selectedRow === index ? null : index);
//   };
//   const [showDatePicker, setShowDatePicker] = useState(false);
//   const [selectedTenantId, setSelectedTenantId] = useState(null);
//   const [selectedDate, setSelectedDate] = useState(new Date());

//   const revoke = (item) => {
//    // setEditUser(true);
//     //setSelectedData(item);
//     setRevokeTenantModal (true);
//     setOpenActionMenu(null);
//   };

//   const ActionBtns = (item) => {
//     const openMenu = (id) => {
//       //setPreviousId(openActionMenu);
//       setOpenActionMenu((prevId) => {
//         return prevId === id ? null : id;
//       });
//     };

//     return (
//       <ActionBtnWrapper>
//         {openActionMenu === item.tenantId && (
//           <MenuOptions id="menuOptions">

//               <MenuItem title="Revoke Moveout" onClick={() => revoke(item)}>
//                 <MdModeEdit className="text-gray-700 mr-2" /> Revoke Moveout
//               </MenuItem>
//           </MenuOptions>
//         )}
//         <Btn title="Actions" type="button" onClick={() => openMenu(item.tenantId)}>
//           <IoMdMore className="text-gray-600" size={24} />
//         </Btn>
//       </ActionBtnWrapper>
//     );
//   };

//   useEffect(() => {
//     if (ApiData) {
//       const tempData = ApiData.map((item) => ({
//         tenantName: getTenantName(item),
//         clientName: getOwnerName(item),
//         getProperty: getProperty(item),
//         rent: "₹" + item.rent,
//         dues: getDues(item),
//         roomNum: getBedsFloors(item),
//         moveInOutDate: moveInOutDate(item),
//         moveOutDate: getMoveOutDate(item),
//         status: combineStatusAndKyc(item),
//         action: ActionBtns(item),
//       }));
//       setData(tempData);
//     }
//   }, [ApiData, openActionMenu]);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (
//         !event.target.closest("#menuOptions") &&
//         !event.target.closest(".action-btn")
//       ) {
//         setOpenActionMenu(null);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const getTenantName = (item) => {
//     return (
//       <UserImageWrapper>
//         <UserImage src={Images.Avatar} alt={`Avatar for ${item.tenantName}`} />
//         <div className="flex flex-col gap-1">
//           <span className="text-zinc-900 font-medium">
//             {item.tenantName}{" "}

//           </span>
//           <span className="text-amber-500 text-xs">#{item.tenantMobile}</span>
//         </div>
//       </UserImageWrapper>
//     );
//   };

//   const getOwnerName = (item) => {
//     return (
//       <div className="flex flex-col gap-1">
//         <span className="text-zinc-900 font-medium">
//           {item.clientName}{" "}
//         </span>
//       </div>

//     );
//   };

//   const getStatus = (status) => {
//     if (status === 1) {

//       return <Initiated>Initiated</Initiated>;
//     } else if (status === 2) {
//       return <Moveout>Move Out</Moveout>;
//     }
//   };

//   const combineStatusAndKyc = (item) => {
//     const statusElement = getStatus(item.status);
//     return (
//       <div className="flex gap-1">
//         <span>{statusElement}</span>
//       </div>
//     );
//   };

//   const goToDues = (clickOn, item) => {
//     navigate(`/tenantdetails/${item.tenantId}`, {
//       state: {
//         tabName: clickOn,
//         tabKey: "totalDues",
//       },
//     });
//   };

//   const getDues = (item) => {
//     return (
//       <span className="bg-rose-500 text-white w-16 py-2 flex items-center justify-center rounded-lg text-xs">
//         <span
//           className={`${"cursor-pointer font-semibold"}`}
//           onClick={() => goToDues("Passbook", item)}
//         >
//           {"₹" + (item?.totalDues || 0)}
//         </span>
//       </span>
//     );
//   };

//   const getProperty = (item) => {
//     return (
//       <div className="flex flex-col gap-1">
//         <span className="text-zinc-600 font-medium">
//           {item.propertyName}{" "}
//         </span>
//         <span className="text-zinc-500 text-xs">{item.clientName}</span>
//       </div>
//     );
//   };

//   const getBedsFloors = (item) => {
//     return (
//       <span className={`bg-neutral-100 text-gray-600 px-3 py-1 rounded-md text-sm cursor-pointer`}>
//         {'#' + item?.roomNum + ", " + item?.flatName}
//       </span>

//     );
//   };

//   const moveInOutDate = (item) => {
//     return (
//       <div className="flex gap-3 ">
//         <div className="flex flex-col ">
//           <span>
//             {item.moveInDate
//               ? moment(item.moveInDate).format("DD-MM-YYYY")
//               : "---"}
//           </span>
//           <span className="text-gray-400 font-medium text-xs">M.In Date</span>
//         </div>
//       </div>
//     );
//   };

//   // const getMoveOutDate = (item) => {
//   //   return (
//   //     <div className="flex gap-3 ">
//   //       <div className="flex flex-col ">
//   //         <span>
//   //           {item.moveInDate

//   //             ? moment(item.moveOutDate).format("DD-MM-YYYY")
//   //             : "---"
//   //           }
//   //         </span>
//   //         <span className="text-gray-400 font-medium text-xs">M.Out Date</span>
//   //       </div>
//   //     </div>
//   //   );
//   // };

//   const getMoveOutDate = (item) => {
//   return (
//     <div className="flex flex-col relative">
//       <input
//         type="date"
//         id={`moveout-${item.tenantId}`}
//         className="absolute opacity-0 pointer-events-none"
//         value={
//           item.moveOutDate
//             ? moment(item.moveOutDate).format("YYYY-MM-DD")
//             : ""
//         }
//         onChange={(e) => {
//           const newDate = e.target.value;
//           if (!newDate) return;

//           updateMoveOutMutate({
//             tenantId: item.tenantId,
//             moveOutDate: newDate,
//           });
//         }}
//       />

//       <span
//         className="cursor-pointer text-blue-600 font-medium hover:underline"
//         onClick={() =>
//           document.getElementById(`moveout-${item.tenantId}`).showPicker()
//         }
//       >
//         {item.moveOutDate
//           ? moment(item.moveOutDate).format("DD-MM-YYYY")
//           : "Select Date"}
//       </span>

//       <span className="text-gray-400 text-xs">M.Out Date</span>
//     </div>
//   );
// };

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobileView(window.innerWidth < 768);
//     };

//     window.addEventListener("resize", handleResize);

//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   const columns = React.useMemo(() => {
//     if (isMobileView) {
//       // Display only "User" column for mobile screens
//       return [
//         {
//           Header: "Tenant Name",
//           accessor: "tenantName",
//         },
//         {
//           Header: "Owner Name",
//           accessor: "clientName",
//         },
//       ];
//     }
//     return [
//       {
//         Header: "Tenant Name",
//         accessor: "tenantName",
//       },
//       {
//         Header: "Owner Name",
//         accessor: "clientName",
//       },
//       {
//         Header: "Status",
//         accessor: "status",
//       },
//       {
//         Header: "Move In Date",
//         accessor: "moveInOutDate",
//       },
//       {
//         Header: "Move Out Date",
//         accessor: "moveOutDate",
//       },
//       {
//         Header: "Action",
//         accessor: "action",
//       },
//     ];
//   }, [isMobileView]);
//   const {
//     getTableProps,
//     getTableBodyProps,
//     headerGroups,
//     prepareRow,
//     pageOptions,
//     page,
//     state: { pageIndex },
//     previousPage,
//     nextPage,
//     canPreviousPage,
//     canNextPage,
//   } = useTable(
//     {
//       data,
//       columns,
//       initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
//     },
//     useSortBy,
//     usePagination
//   );
//   useEffect(() => {
//     setCurrentPage(pageIndex); // Update current page on state change
//   }, [pageIndex]);

//   return (
//     <>
//       <CustomTable {...getTableProps()}>
//         <Thead>
//           {headerGroups.map((headerGroup) => (
//             <Tr {...headerGroup.getHeaderGroupProps()}>
//               {headerGroup.headers.map((column) => (
//                 <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
//                   {column.render("Header")}
//                   <span>
//                     {column.isSorted ? (
//                       <img
//                         src={Images.Arrow}
//                         alt="down arrow"
//                         className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
//                           } w-1.5 inline-block ml-1.5`}
//                       />
//                     ) : (
//                       ""
//                     )}
//                   </span>
//                 </Th>
//               ))}
//             </Tr>
//           ))}
//         </Thead>
//         <Tbody
//           {...getTableBodyProps()}
//           className={ApiData?.length > 0 ? "border-b" : ""}
//         >
//           {page.map((row, rowIndex) => {
//             prepareRow(row);
//             return (
//               <React.Fragment key={rowIndex}>
//                 <Tr
//                   {...row.getRowProps()}
//                   className={ApiData?.length > 0 ? "border-b" : ""}
//                 >
//                   {row.cells.map((cell, cellIndex) => {
//                     return (
//                       <Td
//                         {...cell.getCellProps()}
//                       >
//                         {cell.render("Cell")}
//                       </Td>
//                     );
//                   })}
//                 </Tr>
//                 {selectedRow === rowIndex && window.innerWidth < 768 && (
//                   <Tr>
//                     <Td colSpan={columns.length}>
//                       <ul className="flex flex-col gap-2">
//                         <li>
//                           <strong>Bed/Floor</strong> {data[rowIndex].roomNum}
//                         </li>
//                         <li>
//                           <strong>Move In/Out Date</strong>{" "}
//                           {data[rowIndex].moveInOutDate}
//                         </li>
//                         <li>
//                           <strong>Bed/Floor</strong> {data[rowIndex].roomNum}
//                         </li>
//                         <li className="flex gap-2">
//                           <strong>Status/KYC Status</strong>{" "}
//                           {data[rowIndex].status}
//                         </li>
//                         <li>
//                           <strong>Action:</strong> {data[rowIndex].action}
//                         </li>
//                       </ul>
//                     </Td>
//                   </Tr>
//                 )}
//               </React.Fragment>
//             );
//           })}
//         </Tbody>
//       </CustomTable>
//       {ApiData?.length > 0 && (
//         <PaginationWrapper>
//           <div className="px-2">
//             Page{" "}
//             <em>
//               {pageIndex + 1} of {pageOptions.length}
//             </em>
//           </div>

//           <div className="flex gap-1">
//             <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
//               <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
//             </PrevBtn>
//             <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
//               <img
//                 src={Images.Arrow}
//                 alt="arrow"
//                 className="w-2 rotate-180 opacity-75"
//               />
//             </NextBtn>
//           </div>
//         </PaginationWrapper>
//       )}
//       {ApiData?.length === 0 && <NotFoundModel />}
//     </>
//   );
// };

// const MenuOptions = tw.div`absolute bottom-10 right-0 py-4 w-max bg-white z-50 rounded-lg shadow-lg border border-gray-200 flex flex-col`;
// const MenuItem = tw.div`flex items-center gap-2 px-4 py-2 text-base font-medium cursor-pointer hover:bg-gray-100`;
// const Btn = tw.button`action-btn grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;
// const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
// const CustomTable = tw.table` w-full text-zinc-600`;
// const Thead = tw.thead`border-b uppercase text-zinc-500 bg-slate-100`;
// const Tbody = tw.tbody`${({ hasdata }) => (hasdata ? "border-b" : "")}`;
// const Tr = tw.tr`${({ hasdata }) =>
//   hasdata ? "border-b" : ""} rounded-md overflow-hidden hover:bg-slate-50`;
// const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-medium text-gray-500`;
// const Td = tw.td`p-3 text-sm md:p-3 text-left`;
// const UserImageWrapper = tw.div` flex items-center gap-2`;
// const UserImage = tw.img`w-9 h-9 rounded-full `;
// const Initiated = tw.div`bg-yellow-100 text-yellow-700 text-xs border-yellow-300 border w-24 h-7 flex items-center justify-center rounded-full`;
// const Moveout = tw.div`bg-blue-100 text-blue-700 text-xs border-blue-300 border w-24 h-7 flex items-center justify-center rounded-full`;
// export default Table;
